module.exports = __webpack_public_path__ + "static/media/banner_desenvolvimento_ti.f2bdbf89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/DesenvolvimentoTI/banner_desenvolvimento_ti.png
// module id = 59
// module chunks = 0